import qs from 'qs';
import { safetyHandler } from '../../../enums/utils';
import { sendIpstackRequest } from '../../../utils/ipstack';
import { memoizePromise } from '../../../utils/memoizePromise';

export const ChildType = new Proxy(
  {
    LOCATION: 'Location',
    DISTANCE: 'Distance',
  },
  safetyHandler('ChildType'),
);

export const getChildLink = (subCategory, elementType, searchParams = {}) => {
  if (!subCategory) return {};
  const labelElement = (subCategory.labels || []).find(
    ({ type }) => type === elementType,
  );
  const imageElement = (
    (subCategory.content &&
      subCategory.content.pageInfo &&
      subCategory.content.pageInfo.images) ||
    []
  ).find(({ type }) => type === elementType);

  const childLink = {
    text: labelElement ? labelElement.value : null,
    image: imageElement ? imageElement.url : null,
    link: subCategory.path
      ? `/${subCategory.path}?${qs.stringify(
          { ...searchParams, page: 1 },
          {
            skipNulls: true,
          },
        )}`
      : null,
    eventCount: subCategory.eventCount,
  };

  return childLink;
};
const sortByEventCount = (chA, chB) => chB.eventCount - chA.eventCount;

export const getLocationLinks = (locationChildren, searchParams) => {
  return locationChildren && locationChildren.length
    ? locationChildren
        .map((child) => getChildLink(child, ChildType.LOCATION, searchParams))
        .filter(({ eventCount }) => eventCount)
        .sort(sortByEventCount)
    : [];
};

const memoizedIpStackRequest = memoizePromise(sendIpstackRequest);
export const getNearMeSearchParams = async (searchParams) => {
  const result = await memoizedIpStackRequest();

  return {
    ...searchParams,
    locationSearchRadius: 50,
    locationLat: result.latitude,
    locationLong: result.longitude,
  };
};

// fetches location based on ip address
export const getNearMeLink = async (currentPath, _searchParams) => {
  const locationName = 'Near Me';

  const searchParams = await getNearMeSearchParams({
    ..._searchParams,
    selectedLocationName: locationName,
  });

  return {
    text: locationName,
    image:
      'https://res.cloudinary.com/letsdothiscom/image/upload/v1551356228/static-assets/map.png',
    link: `/${currentPath}?${qs.stringify(searchParams, {
      skipNulls: true,
    })}`,
  };
};

export const typeOrderedFind = (elements, elementTypes) => {
  const results = elementTypes
    .map((elementType) =>
      elements.find((labelType) => labelType.type === elementType),
    )
    .filter(Boolean);

  if (results.length) {
    return results[0];
  }

  return null;
};

export const getTypeOrdredChildLinks = (subCategory, elementTypes) => {
  if (!subCategory) return {};
  const labelElement = typeOrderedFind(subCategory.labels || [], elementTypes);
  const imageElement = typeOrderedFind(
    (subCategory.content &&
      subCategory.content.pageInfo &&
      subCategory.content.pageInfo.images) ||
      [],
    elementTypes,
  );

  return {
    text: labelElement ? labelElement.value : null,
    image: imageElement ? imageElement.url : null,
    link: subCategory.path ? `/${subCategory.path}` : null,
    eventCount: subCategory.eventCount,
  };
};

export const getDistanceLinks = (
  distanceChildren,
  searchParams,
  filterDistanceType = false, // sometimes the results are prefiltered.
) => {
  if (distanceChildren && distanceChildren.length) {
    const children = filterDistanceType
      ? distanceChildren.filter(
          ({ type }) => type?.toUpperCase() === 'DISTANCE',
        )
      : distanceChildren;

    const distanceLinks = children
      .map((child) => getChildLink(child, ChildType.DISTANCE, searchParams))
      .filter(({ eventCount }) => eventCount)
      .sort(sortByEventCount);

    return distanceLinks;
  }
  return [];
};
